import { Component, HostListener, Inject, OnDestroy, OnInit, signal, computed, inject, DestroyRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WelcomeSurveyDialogData } from '../../dialogs-data/welcome-survey-dialog-data';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-welcome-survey-dialog',
    templateUrl: './welcome-survey-dialog.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule
    ]
})
export class WelcomeSurveyDialogComponent implements OnInit, OnDestroy {
    private destroyRef = inject(DestroyRef);
    private matDialogRef = inject(MatDialogRef<WelcomeSurveyDialogComponent>);

    public welcomeSurveyDialogData =
    inject<WelcomeSurveyDialogData>(MAT_DIALOG_DATA);

    // Signals for reactive state
    private isVisible = signal<boolean>(true);

    // Computed properties
    isDialogVisible = computed(() => this.isVisible());

    constructor() {
    }

    ngOnInit() {
    }

    close(value: any) {
        this.isVisible.set(false);
        this.matDialogRef.close(value);
    }

    @HostListener('keydown.esc')
    public onEsc() {
        this.close('ESC keydown');
    }

    ngOnDestroy() {
    }
}
